import React, { useState } from 'react'
import { Check } from 'react-feather';
import { ReactComponent as SEARCHICON } from "../../../assets/icons/search.svg";


const Clientsfilter = ({ setShowModal, clients, setSelectedClients, selectedClients,isLast, isClientFilter = false, hideCount = false  }) => {
  const [filters, setFilters] = useState(selectedClients);
  const [searchClient, setSearchClient] = useState("");
  const [selectAll, setSelectAll] = useState(false);

  const handleCheck = (client) => {

    if (selectAll) {
      setSelectAll(false);
    }
    if (filters.includes(isClientFilter ? client.name : client.email)) {
      setFilters(f => f.filter(d => isClientFilter ? d !== client.name : d !== client.email));
    } else {
      setFilters(f => [...f, isClientFilter ? client.name : client.email]);
    }
  }

  const handleApply = (filters) => {
    if (selectAll) {
      setSelectedClients(clients.map(c => isClientFilter ? c.name: c.email));
    } else {
      setSelectedClients(filters);
    }
    setShowModal("");
  }

  const handleClear = () => {
    setFilters([]);
    setSelectedClients([]);
    setShowModal("");
  }

  return  <div className={`accountDetailsFilterPopup ${isLast ?"sm:left-0 lg:left-0 md:left-[-50px] left-[-50px]": "left-0" }`}>
    <div className="accountLanguageFilterSearch">
      <input
        className="accountLanguageFilterSearchInput"
        placeholder="Search by name,email"
        vlaue={searchClient}
        onChange={(e) => setSearchClient(e.target.value)}
        autoFocus={true}
      />
      <SEARCHICON className="accountLanguageFilterSearchIcon" />
    </div>

    <div className="accountDeatilsFilterItems">
      {<div className="hardCopyCheckboxLine">
        <div className={`${selectAll ? "hardCopyChecked" : ""} hardCopyCheckbox`}>
          <Check className="hardCopyCheck" onClick={() => { setSelectAll(i => !i) }} style={{ opacity: selectAll ? 1 : 0 }} />
        </div>
        <p className="hardCopyCheckboxText" onClick={() => { setSelectAll(i => !i) }}>Select all</p>
      </div>}
      {clients.filter((el) => {
        return el.name && (searchClient?.trim() ? el.name.toLowerCase().includes(searchClient.toLowerCase()) || (!isClientFilter && el.email.toLowerCase().includes(searchClient.toLowerCase())) : true)
      }).map((client, i) => <div key={isClientFilter ? (client.name + i) : client.email} className="hardCopyCheckboxLine">
        <div className={`${filters.includes(isClientFilter ? client.name : client.email) || selectAll ? "hardCopyChecked" : ""} hardCopyCheckbox`}>
          <Check className="hardCopyCheck" onClick={() => { handleCheck(client) }} style={{ opacity: filters.includes(isClientFilter ? client.name : client.email) || selectAll ? 1 : 0 }} />
        </div>
        <div className="flex justify-start items-center gap-1">
          <p className="hardCopyCheckboxText capitalize" onClick={() => { handleCheck(client) }}>{client.name}</p>
          <p className="hardCopyCheckboxText" onClick={() => { handleCheck(client) }}>{`${hideCount ? "" : " (" + (isClientFilter ? client.count : client.email )+ ")"}`}</p>
        </div>
      </div>)}
    </div>

    <div className="accountDetailsFilterPopupBtns">
      <button className="accountOrderBtn accountClearBtn" onClick={() => { handleClear() }}>Clear</button>
      <button disabled={filters.length === 0 && selectAll === false} className="accountOrderBtn" onClick={() => { handleApply(filters) }}>Apply</button>
    </div>
  </div>
}

export default Clientsfilter;